var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 238,
    viewBox: "0 0 239 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.11 161.292C120.368 161.185 120.768 161.035 120.849 160.737C122.509 154.589 123.587 149.168 126.333 143.362C133.295 128.64 147.581 121.406 163.034 118.878C166.329 118.339 177.436 116.749 180.048 118.051C182.667 120.789 179.398 139.287 178.355 143.202C173.507 160.166 163.243 171.061 146.112 175.969C137.313 178.49 131.914 178.434 123.223 178.796C96.8691 179.896 70.0945 172.748 62.581 144.051C61.5333 140.915 56.7865 118.187 61.5837 117.85C72.3516 117.093 85.0525 119.536 94.9532 124.221C105.322 129.128 112.787 138.134 116.553 148.95C117.865 152.718 118.635 156.521 119.631 160.394L120.11 161.292Z",
    fill: "#8EC73F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.556 168.388C120.247 166.706 119.17 161.644 119.631 160.398L120.11 161.296C120.467 161.37 120.494 161.339 120.758 161.579C120.832 163.808 120.669 166.152 120.556 168.388Z",
    fill: "#DBFAB8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.587 59.4609C121.463 59.4793 123.33 61.2039 124.527 62.5347C137.119 76.5437 144.359 94.1796 134.701 112.111C132.253 116.655 125.74 127.436 120.744 129.054C120.41 129.048 119.172 129.006 118.96 128.875C113.88 125.733 107.29 115.613 104.904 110.594C100.101 100.492 100.016 92.2064 103.391 81.9268C105.335 76.0084 114.272 61.9713 119.587 59.4609Z",
    fill: "#8EC73F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbs);
export default __webpack_public_path__ + "static/media/carbs.a3f890f1aac3c81839850a65c343c4c5.svg";
export { ForwardRef as ReactComponent };